import React from "react";
import { Image } from "antd";
import NoImage from "../../assets/Images/no-image.png";
import { IProductsImage } from "interfaces/ClientInterface/IProduct";

const ProductImage = (props: IProductsImage) => {
  const { imageWidth, imageHeight, isPreview, className, imageUrl } = props;
  return (
    <Image
      className={className}
      src={imageUrl}
      preview={isPreview}
      width={imageWidth}
      height={imageHeight}
      fallback={NoImage}
      alt="product-image"
    />
  );
};

export default ProductImage;
